import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import Presentation from '../../logic/redux/presentation';
import { useIntl } from 'react-intl';

const ToastPresenter = (): null => {
  const toast = useSelector(Presentation.select.selectToast);
  const intl = useIntl();
  const { addToast } = useToasts();

  useEffect(() => {
    if (toast) {
      addToast(intl.formatMessage({ id: toast.content }), toast.options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast]);

  return null;
};

export default ToastPresenter;
